//declare var Swiper: any
declare var $

import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
//import 'swiper/css';
//import 'swiper/css/pagination';

export class Header {
  el: HTMLElement
  swiperEl: HTMLElement
	swiper: Swiper

  constructor(el) {
		this.el = el
    this.swiperEl = $('.swiper', this.el).get(0)
		this.init()
	}

  init() {
    this.swiper = new Swiper(this.swiperEl, {
      modules: [ Pagination, Autoplay ],

      autoplay: true,
      speed: 1000,

      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      }
    })
  }
}